<template>
  <SalesRegisterTableCard :isEmpty="! tableItems || ! tableItems.length">
    <table class="table register-table">
      <thead>
        <tr>
          <th>Voucher Date</th>
          <th>Party Name</th>
          <th>Txn Ref No</th>
          <th class="num">Receipt Amount</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td class="text-nowrap fw-bold">{{ item.receipt_date }}</td>
          <td>{{ item.party }}</td>
          <td class="text-nowrap">{{ item.voucher_no }}</td>
          <td class="num">{{ commaFormat(item.total_paid_amount) }}</td>
          <td class="text-center">
            <div class="d-inline-flex gap-1">
              <button v-if="!isHideEditAndReturnButton" class="row-icon-btn"
                      title="View"
                      @click="$emit('edit', item.id)"
                      :disabled="item.status === 'returned'">
                <i class="fas fa-eye"></i>
              </button>
              <button v-if="item.status !== 'returned' && !isHideEditAndReturnButton" class="row-icon-btn is-danger"
                      title="Return"
                      @click="$emit('return', item.id)">
                <i class="far fa-window-close"></i>
              </button>
              <button v-if="!isHidePrintButton" class="row-icon-btn"
                      title="Print"
                      @click="$emit('print', item.id)">
                <i class="fas fa-print"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </SalesRegisterTableCard>
</template>

<script setup>
import figureFormatter from '@/services/utils/figureFormatter';
import SalesRegisterTableCard from '@/components/molecule/company/inventory/product-sales-register/SalesRegisterTableCard.vue';
const { commaFormat } = figureFormatter();

defineProps({
  tableItems: {
    type: Array,
    required: true,
    default: () => []
  },
  isHideEditAndReturnButton: {
    type: Boolean,
    default: true
  },
  isHidePrintButton: {
    type: Boolean,
    default: false
  }
});

defineEmits(['edit', 'return', 'print']);
</script>

<style scoped>
.register-table tbody td {
  padding: 10px 14px !important;
}
.row-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  background: #fff;
  color: #7367f0;
  font-size: 12px;
  cursor: pointer;
  transition: all .15s ease;
}
.row-icon-btn:hover {
  border-color: #7367f0;
  background: #f4f3ff;
}
.row-icon-btn.is-danger {
  color: #d92d20;
}
.row-icon-btn.is-danger:hover {
  border-color: #fda29b;
  background: #fef3f2;
}
.row-icon-btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}
</style>
